export const musculoskeletal = (() => {
    const placeHolderText = 'No joint pain, swelling, deformity or swelling.'

    return placeHolderText
})
